/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { Observable } from 'rxjs';
import { map ,filter } from 'rxjs/operators';
import { ProxyService } from '@core/services';

import { MetaData } from '../models/meta-data';
import { LoggingService } from '@core/services/logging.service';
import { ApiRoutes } from '@shared/models/configs/api.endpoints';
@Injectable({
  providedIn: 'root',
})
export class MetadataService {
  constructor(    
    private proxy: ProxyService,
    private logger: LoggingService) {
  }
  private getMetadataBySlugResponse(slug?: string): Observable<StrictHttpResponse<MetaData>> {
    
    return this.proxy.httpGet(ApiRoutes.METADATA + '?slugs='+slug).pipe(
        filter(_r => _r instanceof HttpResponse),
        map((_r) => {
          return _r as StrictHttpResponse<MetaData>;
        })
      );
  }

  getMetadataBySlug(slug?: string): Observable<MetaData> {
    return this.getMetadataBySlugResponse(slug).pipe(
      map(_r => _r.body as MetaData)
    );
  }
}